export default function componentStyleOverrides(theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          fontWeight: 500,
          borderRadius: '2px',
          // color: theme.paper,
          padding: '10px 15px',
          textTransform: 'uppercase',
          boxShadow: 'none',
          '&.MuiButton-containedSuccess': {
            backgroundColor: theme.paper,
            color: theme.colors?.primaryDark,
          },
          '&.MuiButton-containedError': {
            backgroundColor: theme.paper,
            color: theme.colors?.errorMain,
          },
          '&.MuiButton-containedGrey': {
            backgroundColor: theme.paper,
            color: theme.colors?.secondaryMain,
          },
          '&.MuiButton-containedPrimary': {
            color: theme.paper,
          },
          '&.MuiButton-outlined': {
            borderColor: theme.colors?.grey500,
          },
          '&.Mui-disabled': {
            color: theme.colors?.grey700,
            opacity:0.6
          },
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          color: theme.colors?.grey600,
          '&.Mui-selected': {
            color: theme.colors?.secondaryMain,
            fontWeight: 'bold',
          },
        },
        indicator: {},
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          // fontWeight: 500,
        },
      },
    },
    MuiStack: {
      styleOverrides: {
        root: {
          // fontWeight: 500,
          marginLeft: '9px !important',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          paddingTop: '0px',
          paddingBottom: '0px',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          paddingTop: '10px',
          paddingBottom: '10px',
        },
      },
    },
    MuiPaper: {
      defaultProps: {
        elevation: 0,
      },
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
        rounded: {
          borderRadius: `${theme?.customization?.borderRadius}px`,
        },
      },
    },
    MuiBox: {
      styleOverrides: {
        root: {
          // backgroundColor: '#fff',
          padding: '24px',
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          color: theme.colors?.textDark,
          padding: '24px',
        },
        title: {
          fontSize: '1.125rem',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiCardActions: {
      styleOverrides: {
        root: {
          padding: '24px',
        },
      },
    },
    MuiListItemButton: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
          color: theme.darkTextPrimary,
          paddingTop: '10px',
          paddingBottom: '10px',
          '&.Mui-selected': {
            color: theme.menuSelected,
            backgroundColor: theme.menuSelectedBack,
            '&:hover': {
              backgroundColor: theme.menuSelectedBack,
            },
            '& .MuiListItemIcon-root': {
              color: theme.menuSelected,
            },
          },
          '&:hover': {
            backgroundColor: theme.menuSelectedBack,
            color: theme.menuSelected,
            '& .MuiListItemIcon-root': {
              color: theme.menuSelected,
            },
          },
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: theme.darkTextPrimary,
          minWidth: '36px',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          color: theme.textDark,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        input: {
          // color: theme.paper,
          background: theme.paper,
          '&::placeholder': {
            color: '#000',
            fontSize: '0.875rem',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          marginTop: 0,
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        columnHeaders: {
          backgroundColor: theme.colors?.grey500,
        },
        columnHeaderTitle: {
          fontWeight:'bold'
        },
        filterFormValueInput:{
          '& .MuiAutocomplete-root': {
            paddingTop:"5px",
            '& .MuiFormLabel-root': {
              transform:'translate(0px, -8px) scale(0.75)'
            },
            '& .MuiOutlinedInput-root': {
              paddingLeft:0,
              '& .MuiOutlinedInput-input':{
                padding:'10px 0 0 0',
              },
              '& .MuiOutlinedInput-notchedOutline':{
                border: "none",
                borderBottom: "1px solid",
                borderColor:theme.colors?.secondaryMain,
                borderRadius: 0,
              },
              '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline':{
                 borderWidth:"2px",
                  borderColor: theme.colors?.primaryMain,
                },
              }
            }
           
          }
        }
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          background: theme.paper,
          // height: '40px',
          borderRadius: `${theme?.customization?.buttonBorderRadius}px`,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors?.grey400,
          },
          '&:hover $notchedOutline': {
            borderColor: theme.colors?.primaryLight,
          },
          '&.MuiInputBase-multiline': {
            padding: 1,
            height: 'auto',
          },
          '&.Mui-disabled': {
            background:'#0000000d'
          },
        },
        input: {
          fontWeight: 500,
          background: theme.paper,
          padding: '10px',
          boxSizing: 'border-box',
          height: '40px',
          borderRadius: `${theme?.customization?.buttonBorderRadius}px`,
          '&.MuiInputBase-inputSizeSmall': {
            padding: '10px 14px',
            '&.MuiInputBase-inputAdornedStart': {
              paddingLeft: 0,
            },
          },
          '&.Mui-disabled': {
            background:'transparent'
          },
        },
        inputAdornedStart: {
          paddingLeft: 4,
        },
        notchedOutline: {
          borderRadius: `${theme?.customization?.buttonBorderRadius}px`,
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            padding: '0 15px 0 5px',
          },
        },
        input: {
          paddingLeft: '10px',
        },
      },
    },
    MuiSlider: {
      styleOverrides: {
        root: {
          '&.Mui-disabled': {
            color: theme.colors?.grey300,
          },
        },
        mark: {
          backgroundColor: theme.paper,
          width: '4px',
        },
        valueLabel: {
          color: theme?.colors?.primaryLight,
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.divider,
          opacity: 1,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          color: theme.colors?.primaryDark,
          background: theme.colors?.primary200,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          '&.MuiChip-deletable .MuiChip-deleteIcon': {
            color: 'inherit',
          },
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          color: theme.paper,
          background: theme.colors?.grey700,
          padding: '6px 16px !important',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          '&.MuiTableCell-root':{
            padding: '8px 16px'
          },
          '&.MuiTableCell-head':{
            padding: '8px 16px',
            background: theme.colors?.grey500,
            fontWeight: 'bold'
          },
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          '.modal-wrapper h2 button': {
            top: '24px',
          },
          '.small' : {
            width: '100%',
            maxWidth: '480px',            
          }
        },
      },
    },
  };
}
